import { render, staticRenderFns } from "./InviteUserPopup.vue?vue&type=template&id=596cd30e&scoped=true"
import script from "./InviteUserPopup.vue?vue&type=script&lang=js"
export * from "./InviteUserPopup.vue?vue&type=script&lang=js"
import style0 from "./InviteUserPopup.vue?vue&type=style&index=0&id=596cd30e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596cd30e",
  null
  
)

export default component.exports